import { AfterViewInit, Component } from '@angular/core';
import * as vars from "../../../app.global";
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { User } from 'app/modules/core/models/user';
import { PasswordService } from 'app/modules/core/services/user/password.service';
import { error } from 'console';
import { UIService } from 'app/modules/core/services/ui/ui.service';


@Component({
    selector: 'reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.css'],
    standalone: false
})
export class ResetPasswordComponent implements AfterViewInit {
  version: string = vars.version;
  user: User = new User();
  patternemail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  resetPasswordForm = new UntypedFormGroup({
    password: new UntypedFormControl('', [
      Validators.required
    ]),
    confirmPassword: new UntypedFormControl('', [Validators.required])
  });
  verificationCode: number;

  constructor(private _route: ActivatedRoute,
    private _passwordService: PasswordService,
    private _uiService: UIService
  ) { }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this._route.queryParams.subscribe((params) => {
        this.verificationCode = params["code"];
      });
    }, 10);
  }

    resetPassword() {
      let body = {
        verificationKey: this.verificationCode,
        newPassword: this.resetPasswordForm.controls['password'].value
      }
      if (this.resetPasswordForm.controls['password'].value === this.resetPasswordForm.controls['confirmPassword'].value) {
        this._passwordService.setUserPassword(body).subscribe(
          (response) => {
            this._uiService.showSuccessToast("Password set successfully.")
          },
          (error) => {
            this._uiService.showErrorToast(error.error)
          }
        )
      }
      else {
        this._uiService.showErrorToast("Password and Confirm Password not same.")
      }
    }
}

